import Vue from 'vue'
import Vuex from 'vuex'
import cities from './modules/cities'
import districts from './modules/districts'
import duties from './modules/duties'
import streets from './modules/streets'
import tour from './modules/tour'
import tourTemplate from './modules/tourTemplate'
import devices from './modules/devices'
import auth from './modules/auth'
import user from './modules/user'
import companies from './modules/companies'
import vehicle from './modules/vehicle'
import search from './modules/search'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loader: false
  },
  mutations: {
    LOADER (state, payload) {
      state.loader = payload
    }
  },
  modules: {
    cities,
    districts,
    duties,
    streets,
    tour,
    tourTemplate,
    devices,
    auth,
    user,
    companies,
    vehicle,
    search
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js